import moment from 'moment'
export default {
    install(Vue, options) {
        Vue.mixin({
            beforeCreate() {
                Vue.filter('formatDate', function (value) {
                    if (value) {
                        return moment(String(value)).format('MM/DD/YYYY')
                    }
                })
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/scripts/VueFormatsSetup.js